<template>
    <div class="l-f">
        <div class="l-f-c">
            <div class="l-f-c-1">
                <div class="l-f-c-t">
                    <p class="p-lv">基于区域医联体模式的国产创新诊疗设备服务云平台</p>
                </div>
                <div class="l-f-c-qrc">
                    <img src="../assets/image/login/qrcode.png"> 
                    <img src="../assets/image/login/qrcode.png">
                </div>
                <p class="l-f-c-1-p" style="padding-bottom:10px;">
                    版权所有 重庆医科大学附属第二医院 
                </p>
                <p class="l-f-c-1-p">Copyright @2020 渝ICP备 15009793号-1</p>
            </div>
            <div class="l-f-c-2">
                <p style="font-size:20px;color:white;">联系我们</p>
                <p>渝中院区地址 中国重庆市渝中区临江路74号</p>
                <!-- <p>院办公室电话 023-63832133（上班时间）</p> -->
                <p>江南院区地址    中国重庆市南岸区茶园B区江南新城天文</p>
                <!-- <p>院办公室电话 023-63887133（上班时间）</p> -->
            </div>
            <div class="l-f-c-2">
                <p style="font-size:20px;color:white;">关于我们</p>
                <p>关于基于区域医联体模式的国产创新诊疗设备服务云平台</p>
                <p>关于重庆医科大学附属第二医院</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'comFooter',
    data(){
        return{
            
        }
    }
}
</script>
<style lang="scss" scoped>
.l-f{
    width:100%;
    height:350px;
    background:url(../assets/image/login/login-foot-bg.png) no-repeat center;
    background-size: cover;
}
.l-f-c{
    width:80%;
    height:100%;
    margin:0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.l-f-c-1{
    padding-top:50px;
    // width:400px;
    height:300px;
    // float: left;
}
.l-f-c-t{
    position: relative;
    padding-left:80px;
    background: url(../assets/image/login/foot-icon.png) no-repeat 20px center;
    // width:315px;
    height:50px;
    p{
        width:100%;
        height:100%;
        color:white;
        line-height: 50px;
        font-size: 20px;
    }
}
.l-f-c-qrc {
    width:300px;
    // padding-left:100px;
    margin:0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom:20px;
    img{
        width:100px;
        height:100px;
        // margin:20px;
    }
}
.l-f-c-1-p{
     width:300px;
     text-align: center;
    margin:0 auto;color:white;font-size:13px;
}
.l-f-c-2{
    width:350px;
    padding-top:100px;
    // float: left;
    margin:0 20px;
    p{
        color:#CDE4FD;
        margin:0;
        width:100%;
        margin-bottom:10px;
        font-size:14px;
    }
}
</style>